import { createRouter, createWebHistory } from 'vue-router'
import LayoutPadrao from 'lg-vue-components/layoutPadrao'

import { routes as gestaoPerido } from '@/modules/gestaoPeriodo'
import { routes as justificativa } from '@/modules/justificativaOcorrencia'
import { routes as relatorios } from '@/modules/relatorios'
import { routes as usuDelegacaoHist } from '@/modules/historicoDelegacao'
import { routes as grupoUsuario } from '@/modules/grupoUsuario'
import { routes as paginaInicial } from '@/modules/paginaInicial'
import { routes as atividadeTipo } from '@/modules/atividadeTipo'
import { routes as naoAutorizado } from '@/modules/naoAutorizado'
import { routes as perfilFrequencia } from '@/modules/perfilFrequencia'
import { routes as configuracoes } from '@/modules/configuracoes'
import { routes as periodos } from '@/modules/periodoApuracao'
import { routes as bloqueioPeriodos } from '@/modules/bloqueioSubperiodos'
import { routes as desboqueioPeriodos } from '@/modules/desbloqueioPeriodo'
import { routes as motivosIndisponibilidade } from '@/modules/motivosIndisponibilidade'
import { routes as indisponibilidade } from '@/modules/Indisponibilidade'
import { routes as ordemDeServico } from '@/modules/ordemDeServico'

import consolidacaoFolha from '@/modules/consolidacaoFolha/routes'
import cercaEletronica from '@/modules/cercaEletronica/routes'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...paginaInicial,
    ...grupoUsuario,
    ...gestaoPerido,
    ...justificativa,
    ...relatorios,
    ...usuDelegacaoHist,
    ...atividadeTipo,
    ...naoAutorizado,
    ...perfilFrequencia,
    ...configuracoes,
    ...periodos,
    ...bloqueioPeriodos,
    ...desboqueioPeriodos,
    ...motivosIndisponibilidade,
    ...indisponibilidade,
    ...ordemDeServico,
    ...cercaEletronica,
    consolidacaoFolha
  ]
})

router.beforeEach((to, from, next) => {
  if (
    to.fullPath.includes('home') &&
    Object.entries(to.params).length > 0 &&
    to.params.constructor === Object &&
    Object.entries(to.query).length >= 0 &&
    to.fullPath !== '/home'
  ) {
    router.push({ name: 'home' })
  }
  if (to.path == '/') {
    next({ name: 'home' })
  }
  next()
})

export default router
